import moment from 'moment';
import { get, map, identity } from 'lodash';

import {
  ANY_BARBER,
  CLEAR_BARBER_AVAILABILITY,
  RECEIVE_BARBER_AVAILABILITY,
  REQUEST_BARBER_AVAILABILITY,
  SET_ACTIVE_DAY,
  SET_ACTIVE_TIME,
  SET_ACTIVE_TIME_BARBER,
} from '../constants';
import { shouldLoadTimesForInterval } from './selectors';
import {
  checkStatus,
  handleRequestError,
  joinQueryStringParams,
  randomItem,
} from '../utils/helpers';
import config from '../../config';

export const clearBarberAvailability = () => ({ type: CLEAR_BARBER_AVAILABILITY });

function requestBarberAvailability() {
  return { type: REQUEST_BARBER_AVAILABILITY };
}

const mapTimes = (times, transformBarber = identity) => map(
  times,
  ({ time, barberRoutes }) => ({
    time,
    barberRoute: transformBarber(barberRoutes),
  })
);

const mapAvailableTimes = (availableTimes, transform) => map(availableTimes,
  ({ day, times }) => ({
    day,
    times: (typeof get(times, '[0]') === 'string' ? times : mapTimes(times, transform)),
  })
);

function receiveBarberAvailability(availableTimes, transform) {
  return {
    type: RECEIVE_BARBER_AVAILABILITY,
    payload: mapAvailableTimes(availableTimes, transform),
  };
}

export function setActiveDay(day, resetTime = true) {
  return {
    type: SET_ACTIVE_DAY,
    payload: day,
    resetTime,
  };
}

export const setActiveTime = time => ({
  type: SET_ACTIVE_TIME,
  payload: time,
});

export const resetActiveTime = () => ({
  type: SET_ACTIVE_TIME,
  payload: '',
});

export const setActiveTimeBarber = barber => ({
  type: SET_ACTIVE_TIME_BARBER,
  payload: barber,
});

const fetchAvailability = (url, transform) => (dispatch) => {
  dispatch(requestBarberAvailability());

  return fetch(url)
    .then(checkStatus)
    .then(availableTimes =>
      dispatch(receiveBarberAvailability(availableTimes, transform))
    )
    .catch(handleRequestError(dispatch));
};

const getShopIdParam = (shopRoute, barberRoute) => (
  shopRoute && barberRoute !== ANY_BARBER
    ? `shopId=${shopRoute}`
    : ''
);

const getExcludeAppointmentParam = appointmentId => (appointmentId ? `excludeAppointmentId=${appointmentId}` : '');
const getKioskParam = kiosk => (kiosk ? 'kiosk=true' : '');

export const fetchBarberAvailability = (
  barberRoute,
  shopId,
  serviceDuration,
  startDay = moment(),
  endDay,
  appointmentId,
  kiosk,
  shopRoute
) => (dispatch, getState) => {
  if (!barberRoute || !shopId || !serviceDuration) return Promise.resolve();

  const start = moment(startDay).format(config.apiDateFormat);
  const end = endDay || moment(startDay).add(6, 'days').format(config.apiDateFormat);
  if (!shouldLoadTimesForInterval(getState(), start, end)) return Promise.resolve();

  const params = joinQueryStringParams([
    getShopIdParam(shopId, barberRoute),
    getExcludeAppointmentParam(appointmentId),
    getKioskParam(kiosk),
  ]);
  const url = `${config.url}/shop/${shopRoute}/barber/${barberRoute}/`
    + `available-time-range/${start}/${end}/${serviceDuration}${params}`;

  return dispatch(fetchAvailability(url));
};

export const fetchShopBarberAvailability = (
  shopRoute,
  selectedServices,
  startDay = moment(),
  endDay,
  appointmentId,
  kiosk,
) => (dispatch, getState) => {
  if (!shopRoute || !selectedServices) return Promise.resolve();

  const start = moment(startDay).format(config.apiDateFormat);
  const end = endDay || moment(startDay).add(6, 'days').format(config.apiDateFormat);

  if (!shouldLoadTimesForInterval(getState(), start, end)) return Promise.resolve();
  const params = joinQueryStringParams([
    getExcludeAppointmentParam(appointmentId),
    getKioskParam(kiosk),
  ]);
  const url = `${config.url}/shop/${shopRoute}/available-time-range/${start}/${end}/${selectedServices}${params}`;

  return dispatch(fetchAvailability(url, randomItem));
};

export function fetchShopAvailability(shopRoute, startDay = moment()) {
  if (!shopRoute) return Promise.resolve();

  const start = moment(startDay).format(config.apiDateFormat);
  const end = moment(startDay).add(6, 'days').format(config.apiDateFormat);
  const url = `${config.url}/shop/${shopRoute}/available-time-range/${start}/${end}`;

  return fetchAvailability(url);
}



// WEBPACK FOOTER //
// ./src/app/times/actions.js